module.exports = __webpack_public_path__ + "img/Depends-On-Where-Im-Going.85518a87.jpg";